import { useMutation, useQueryClient } from '@tanstack/react-query';
import { login as loginApi } from '../../services/apiAuth';
import { useNavigate } from 'react-router-dom';

export function useLogin() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: login, isLoading } = useMutation({
        mutationFn: ({ email, password }) => loginApi({ email, password }),
        onSuccess: (user) => {
            queryClient.setQueryData(['user'], user);
            navigate('/', { replace: true });
        },
        onError: (err) => {
            console.log('ERROR', err);
            alert('Login Error: ' + err.message);
            //toast.error('Provided email or password are incorrect');
        },
    });

    return { login, isLoading };
}
